// import { PERMISSIONS } from "@/utils/constants";
// import permissionMiddleware from "@/router/middlewares/permissionMiddleware";
// import authMiddleware from "@/router/middlewares/authMiddleware";

export default [
  {
    path: "/ozl-orders",
    name: "ozl-orders",
    component: () => import("../pages/admin/ozl/order"),
  },
  {
    path: "/ozl-contracts",
    name: "ozl-contracts",
    component: () => import("../pages/admin/ozl/contract"),
  },
  {
    path: "/ozl-contracts-view",
    name: "ozl-contracts-view",
    component: () => import("../pages/admin/ozl/contract-view"),
  },
];
